//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import eloading from '@/components/eloading/eloading'
	export default {
		data() {
			return {
				url: window.location.href, //当前地址
				// 是否被领取，0 未使用 1 已使用
				used_status: 0,
				// 获得品牌币
				coin_num: 0,
				// 累计币
				coin_num_new: 0,
				// 加载图片数量
				loadImgArr: []
			}
		},
		components: {
			eloading
		},
		beforeCreate() {
			this.$nextTick(() => {
				this.preLoadImgs()
			})
		},
		created() {
			if(sessionStorage.getItem("token") == null) {
			    this.get_token(this.url);
			}else {
				this.get_conf()
				this.getUrlPam()
			}
		},
		computed: {
			jumpEnv() {
				return location.host.indexOf('dev')>-1 ? 'trial' : 'release'
			},
			originalId() {
				// return location.host.indexOf('dev')>-1 ? 'gh_aece25b74170' : 'gh_0781b44c59e1'
				// 临时写死原始id
				return location.host.indexOf('dev')>-1 ? 'gh_aece25b74170' : 'gh_b298b8d2c266'
			}
		},
		methods: {
			// 加载图片
			preLoadImgs() {
				let imgs = [
					require('./image/coin/bg1.png'),
					require('./image/coin/bg2.png'),
					require('./image/coin/bg3.png'),
					require('./image/coin/bg4.png')
				]
				if(this.loadImgArr.length>0) {
					imgs = imgs.filter(v => { return !this.loadImgArr.includes(v) })
				}
				imgs.forEach(v => {
					let img = new Image()
					img.src=v
					img.onload = () => {
						this.loadImgArr.push(v)
					}
				})
			},
			//获取token
			get_token(url) {
			    this.$EpetJs.Common.approve(url,()=> {
					this.get_conf()
					this.getUrlPam()
				}); //生成token
			},
			get_conf() {
			    //微信js授权config
			    this.$EpetJs.Common.get_conf(this.url, (res)=> {
					res.openTagList = res.openTagList || []
					res.openTagList.push('wx-open-launch-weapp')
			        this.$wx.config(res)
			    });
			},
			// 获取链接参数
			getUrlPam() {
				this.used_status = this.$EpetJs.Helper.getUrlParam("used_status") || this.used_status
				this.coin_num = this.$EpetJs.Helper.getUrlParam("coin_num") || this.coin_num
				this.coin_num_new = this.$EpetJs.Helper.getUrlParam("coin_num_new") || this.coin_num_new
			},
			// 跳转查询商品防伪
			toInquire() {
				this.$router.replace('/inquire')
			}
		}
	}
